module.exports = __webpack_public_path__ + "media/32.ed023d6e.ogg";